<p>
  <strong>Pro Tip:</strong> Send error alerts directly to Slack to notify your
  team when there are new errors.
</p>
<div class="row mb-3 align-items-center">
  <div class="col-5">
    <img src="{{ appEnv.cdnUrl }}/{{ appEnv.assetsPath }}/images/slack.svg" />
  </div>
  <div class="col-7">
    <a
      href="/projects/{{ project.id }}/services/12"
      target="_self"
      class="btn btn--success btn--default"
      (click)="dismissAndFollow($event)"
    >
      Add workspace
    </a>
  </div>
</div>
<span class="small">
  Don't use Slack? Check out out our other
  <a
    href="/projects/{{ project.id }}/services/12"
    target="_self"
    (click)="dismissAndFollow($event)"
  >
    messaging integrations</a
  >.
</span>
